<template>

    <div class="translate25-change-locale" style="display: flex; flex-direction: row">
        <FSelect :options="availableLocales" :selected="currentLocaleOption" @update:selected="changeLocaleFSelect">
        </FSelect>
    </div>

</template>
<script lang="ts">


import { i18n } from '/vodalys/vvuejs/vue'


import { debug } from "/vodalys/.jslibs";
const log = debug('translate25:ChangeLocale');


function getLocaleName(localeCode: string): string {

    const primaryLanguageCode = localeCode.split('-')[0];
    // Utiliser la locale elle-même pour afficher son propre nom
    const displayNames = new Intl.DisplayNames([localeCode], { type: 'language' });

    const localeName = displayNames.of(primaryLanguageCode);
    return localeName.charAt(0).toUpperCase() + localeName.slice(1);
}

export default {
    translate25Context: 'translate25',
    data() {
        return {
            locale: i18n.locale,
            navLocale: getLocaleName(navigator.language)
        }
    },
	props: ['component', 'handler'],
    mounted() {
        log('avalable locales', Object.keys(this.$i18n.messages))
        log('current locale', this.locale, this.navLocale)
    },
    computed: {
        availableLocales() {

            const localesOptions = [
                ...Object.keys(this.$i18n.messages).map(locale => {

                    const localeName = getLocaleName(locale)

                    return {
                        locale,
                        key: locale,
                        title: localeName

                    }
                })
            ].sort((a, b) => a.title.localeCompare(b.title))


            localesOptions.unshift(this.autoOption)

            return localesOptions
        },
        currentLocaleOption() {

            if (this.locale === navigator.language) {
                return this.autoOption
            }
            return this.availableLocales.find(locale => this.locale === locale.locale)
        },
        autoOption() {

            const localeName = getLocaleName(navigator.language)
            return {
                locale: 'auto',
                key: undefined,
                title: this.$vt('Use system language')
            }
        }
    },

    methods: {
        changeLocale(locale) {
            this.locale = locale

            if (locale === 'auto') {
                delete localStorage.language
                i18n.locale = navigator.language
                queueMicrotask(async () => {
                    log('changing account language to auto...')
                    await this.handler.action(this.component, 'change_locale', [''])
                    log('changing account language to auto... DONE')
                })
                return
            }
            i18n.locale = locale
            localStorage.language = i18n.locale
            queueMicrotask(async () => {
                log('changing account language to', locale, '...')
                await this.handler.action(this.component, 'change_locale', [locale])
                log('changing account language to', locale, '... DONE')
            })
        },
        changeLocaleSelect(event) {
            this.changeLocale(event.target.value)

        },
        changeLocaleFSelect(localeOption) {
            this.changeLocale(localeOption?.locale ?? 'auto')
        }
    }

}
</script>